/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const usePostponeStore = defineStore("postpone", {
  actions: {
    async postPonesearchFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/postpone/search";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async postPoneInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/postpone/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async postPonehistoryFetch(payload) {
      const body = {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          uid: payload.uid, // workCase Uid
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/postpone/history";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async postPoneAddFetch(payload) {
      const body = {
        workCaseUid: payload.workCaseUid, // always required
        postponeDate: payload.postponeDate,
        days: payload.days,
        remark: payload.remark,
        type: payload.type, // USER, CUSTOMER
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/postpone/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async postPoneDeleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/postpone/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async postPoneListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
          type: payload.type, // empty for both or specific (USER, CUSTOMER)
          dayStart: payload.dayStart, //----+ all (dayStart: 0, dayEnd: 0), range 1-15 (dayStart: 1, dayEnd: 15), more than 90 (dayStart: 90, dayEnd: -1)
          dayEnd: payload.dayEnd, //----|
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          active: payload.active, // true: only active workCase, false: all workCases
          completeToday: payload.completeToday,
          completeInDateRange: payload.completeInDateRange, // use with fromDate, toDate parameter
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-rpt-svc/postpone/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
